import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, Loader2, XCircle, ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("loading"); // loading | paid | pending | failed
  const [productName, setProductName] = useState("");

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { payment_status, product_nombre } = await api.get(`/payments/status/${sessionId}`).then(r => r.data);
        setProductName(product_nombre || "");
        if (payment_status === "paid") { setStatus("paid"); return; }
        if (payment_status === "failed" || payment_status === "expired") { setStatus("failed"); return; }
        tries++;
        if (tries < 8) setTimeout(poll, 1500);
        else setStatus("pending");
      } catch { setStatus("failed"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#050505] text-white font-body flex items-center justify-center px-4" data-testid="payment-success-page">
      <div className="w-full max-w-md text-center">
        {status === "loading" && (
          <>
            <Loader2 size={48} className="mx-auto text-[#FFCC00] animate-spin mb-6" />
            <p className="text-white/60 text-sm">Confirmando tu pago...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={56} className="mx-auto text-green-400 mb-6" />
            <p className="text-[10px] tracking-[0.3em] uppercase font-black text-[#FFCC00] mb-3">Pago confirmado</p>
            <h1 className="font-display text-3xl mb-3">¡Gracias!</h1>
            {productName && <p className="text-white/50 text-sm mb-6">Tu compra de <strong className="text-white">{productName}</strong> ha sido procesada correctamente.</p>}
            <p className="text-white/35 text-xs mb-8">El equipo de XPRO FITNESS se pondrá en contacto contigo para coordinar los detalles.</p>
            <Link to="/mis-compras" data-testid="back-to-portal"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#FFCC00] text-black font-black text-[11px] tracking-[0.2em] uppercase hover:bg-white transition-colors">
              <ArrowLeft size={13} /> Ver mis compras
            </Link>
          </>
        )}
        {status === "pending" && (
          <>
            <Loader2 size={48} className="mx-auto text-yellow-400 mb-6" />
            <p className="text-[10px] tracking-[0.3em] uppercase font-black text-yellow-400 mb-3">Pago en proceso</p>
            <h1 className="font-display text-3xl mb-3">Procesando...</h1>
            <p className="text-white/50 text-sm mb-8">Tu pago está siendo procesado. Te confirmaremos en breve por email.</p>
            <Link to="/mi-rutina" className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 text-white/60 font-black text-[11px] tracking-[0.2em] uppercase hover:border-white/50 hover:text-white transition-colors">
              <ArrowLeft size={13} /> Volver al portal
            </Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle size={56} className="mx-auto text-red-400 mb-6" />
            <p className="text-[10px] tracking-[0.3em] uppercase font-black text-red-400 mb-3">Pago no completado</p>
            <h1 className="font-display text-3xl mb-3">Algo falló</h1>
            <p className="text-white/50 text-sm mb-8">No se ha podido completar el pago. Puedes intentarlo de nuevo.</p>
            <div className="flex gap-3 justify-center">
              <Link to="/tienda" data-testid="back-to-shop"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#FFCC00] text-black font-black text-[11px] tracking-[0.2em] uppercase hover:bg-white transition-colors">
                Volver a la tienda
              </Link>
              <Link to="/mi-rutina" className="inline-flex items-center gap-2 px-6 py-3 border border-white/15 text-white/50 font-black text-[11px] tracking-[0.2em] uppercase hover:text-white transition-colors">
                <ArrowLeft size={13} /> Portal
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
